// React imports
import React from 'react';
import { useLocation, NavLink } from 'react-router-dom';

// Material UI imports
import { Breadcrumbs, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
// Utility import
import {
  WOUND_GOAL_BREADCRUMB_TEXT,
  WOUND_THERAPY_GUIDE_BREADCRUMB_TEXT,
} from '../../utility/staticText';

const useStyles = makeStyles(() => ({
  link: {
    color: '#000000',
    fontSize: '11px',
    lineHeight: '12px',
  },
  noLink: {
    color: '#000000',
    fontSize: '11px',
    lineHeight: '12px',
    paddingTop: '4px',
  },
}));
const SectionBreadcrumbs = () => {
  const classes = useStyles();
  const location = useLocation();
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" color="#1d6460" />}
      aria-label="breadcrumb"
    >
      <NavLink
        to="/"
        underline="always"
        className={classes.link}
        data-testid="home"
      >
        Home
      </NavLink>
      <Typography className={classes.noLink} data-testid="nextPage">
        {location.pathname === '/woundTherapyGuide' &&
          WOUND_THERAPY_GUIDE_BREADCRUMB_TEXT}
        {location.pathname === '/woundGoal' && WOUND_GOAL_BREADCRUMB_TEXT}
      </Typography>
    </Breadcrumbs>
  );
};

export default SectionBreadcrumbs;
